export const PATH = {
	home: '/',
	projects: '/projects',
	about: '/about',
	skills: '/skills',
};
